import { render, staticRenderFns } from "./FlowTest.vue?vue&type=template&id=46227691&lang=pug&"
import script from "./FlowTest.vue?vue&type=script&lang=ts&"
export * from "./FlowTest.vue?vue&type=script&lang=ts&"
import style0 from "./FlowTest.vue?vue&type=style&index=0&id=46227691&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports